// extracted by mini-css-extract-plugin
export default {"container":"_1fe3df82","testDivider":"_be700852"};